export default __webpack_public_path__ + "static/media/fpah1000.582ce438.png";